import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pdf-viewer" }
const _hoisted_2 = {
  key: 0,
  class: "pdf-viewer__placeholder"
}
const _hoisted_3 = { class: "text-center text-muted" }
const _hoisted_4 = {
  key: 0,
  class: "spinner-border mb-3",
  role: "status"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Đang tải...", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.source)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.loading ? _ctx.loadingMessage : 'Không có dữ liệu'), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("iframe", {
      ref: "pdfFrame",
      class: "pdf-viewer__frame",
      src: _ctx.viewerUrl,
      title: "PDF Viewer",
      tabindex: "0",
      onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFrameLoad && _ctx.onFrameLoad(...args)))
    }, null, 40, _hoisted_8), [
      [_vShow, _ctx.source]
    ])
  ]))
}